;(function (angular, _, UUID) {
  'use strict'

  class AddRubricController {
    constructor (
      $uibModal,
      RubricService
    ) {
      this.modal = $uibModal
      this.service = RubricService
    }

    $onInit () {
      this.rs = this.resolve.rubrics || []
      this.newRubricName = ''
      this.isInvisibleRubricVisible = true
    }

    // create marge before label depending on deep (design)
    giveWidth (deep) {
      return this.service.getWidthFromDeep(deep) + 'px'
    }

    giveInputWidth (deep) {
      // 100% - input  + trash button + arrow button (150) + marge
      return 'calc(100% - ' + (170 + parseInt(this.service.getWidthFromDeep(deep))) + 'px);'
    }

    // blue is rubric to show where would the new child rubric go
    newBlue (index, rubric) {
      if (!rubric) return
      this.isInvisibleRubricVisible = false
      let newIndex = index + 1
      let numberOdChild = 0
      while (this.rs[newIndex] && this.rs[newIndex].deep > rubric.deep) {
        if (this.rs[newIndex].deep === rubric.deep + 1) numberOdChild++
        newIndex++
      }
      this.blue = {
        deep: rubric.deep + 1,
        position: (numberOdChild + 1),
        parent: rubric.rubric.parent,
        parentLabel: rubric.label,
        label: rubric.label + '.' + (numberOdChild + 1),
        imBlue: true,
        index: newIndex
      }
      this.rs.splice(newIndex, 0, this.blue)
    }

    // create the new child rubric (=blue rubric)
    fromBlueToNew () {
      this.rs[this.blue.index] = {
        deep: this.blue.deep,
        label: this.blue.label,
        rubric: {
          label: '',
          _id: UUID.genV4().toString(),
          position: this.blue.position,
          parent: this.blue.parent
        }
      }
      this.blue.index++
      this.blue.position++
      this.blue.label = this.blue.parentLabel + '.' + this.blue.position
      this.rs.splice(this.blue.index, 0, this.blue)
    }

    // delete a rubric line (and all its child)
    delRubricLine (index, rubric) {
      let startDelete = index
      let amount = 1
      let RubricArray = rubric.label.toString().split('.').map(function (item) {
        return parseInt(item);
      })
      while (this.rs[index + amount] &&
      this.rs[index + amount].deep > rubric.deep) {
        amount++
      }
      this.rs.splice(startDelete, amount)
      for (let i = index; i < this.rs.length; i++) {
        this.rs[i].label = this.rs[i].label.toString()
        let currentLabelArray = this.rs[i].label.toString().split('.').map(function (item) {
          return parseInt(item);
        })
        if (this.rs[i].deep >= rubric.deep && currentLabelArray[(rubric.deep - 1)] == RubricArray[(rubric.deep - 1)]){
          currentLabelArray[rubric.deep]--
        }
        let newLabel = currentLabelArray.join('.')
        this.rs[i].label = newLabel
        this.rs[i].rubric.position = currentLabelArray[currentLabelArray.length - 1]
      }
    }

    // what is the label of the new top level rubric
    newRubricLabel () {
      if (!this.rs || !this.rs.length) return '1'
      return parseInt(this.rs[this.rs.length - 1].label) + 1
    }

    // add a new top level rubric
    newRubricLine (index) {
      let nbr = this.newRubricLabel()
      if (this.newRubricName.length) {
        this.rs.push({
          deep: 0,
          label: nbr,
          rubric: {
            label: this.newRubricName,
            parent: null,
            position: parseInt(nbr),
            _id: UUID.genV4().toString()
          }
        })
        this.newRubricName = ''
      } else {
        this.focusOnNextInput(index)
      }
    }

    // focus on next input
    focusOnNextInput (index) {
      let nextInput = document.getElementById(index + 1)
      if (nextInput) {
        nextInput.focus()
      } else {
        document.getElementById('new-rubric-input').focus()
      }
    }

    onKeyPress (charCode, index, rubric) {
      if (charCode == 13) {
        this.newRubricLine(index, rubric)
      } else {
        return
      }
    }

    // delete blue rubric
    destroyBlue () {
      if (this.blue) {
        this.isInvisibleRubricVisible = true
        this.rs.splice(this.blue.index, 1)
        this.blue = null
      }
    }

    // save and pass down rubrics
    save () {
      if (this.newRubricName) {
        this.newRubricLine()
      }
      this.close({ $value: this.rs })
    }
  }

  AddRubricController.$inject = [
    '$uibModal',
    'RubricService'
  ]

  angular.module('kilo.common.components')
    .component('addRubric', {
      bindings: {
        resolve: '=',
        close: '&',
        dismiss: '&'
      },
      templateUrl: '/app/modules/compute/rubric/add-rubric.template.html',
      controller: AddRubricController
    })
})(window.angular, window._, window.UUID)
